<script>
import {mapActions, mapGetters} from "vuex";
import {AlertService} from "@/services/AlertService";

export default {
  name: "NewEmail",
  data() {
    return {
      email_address : '',
      modules : []
    }
  },
  methods: {
    ...mapActions('EmailModule',[
      'addEmail'
    ]),
    cancelAdd() {
      this.email_address = '';
      this.modules = [];
    },
    async addNewEmail() {
      const response = await this.addEmail({
        email_address : this.email_address,
        modules : this.modules
      })

      if (response.result === false) {
        AlertService.errorAlert(response.errors.email_address[0], 'CREATION OF NEW EMAIL');
        return;
      }
      $('#NewEmail').modal('hide');
      // AlertService.successAlert('New Email Successfully created!', 'CREATION OF NEW EMAIL');
      this.email_address = ''

      successAlert.fire({
        title: `CREATION OF NEW EMAIL`,
        text : 'New Email Successfully created!',
        showConfirmButton: true,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,
        timer: 1500,
        scrollbarPadding: false
      }).then(async (result)=>{
        if(result.isConfirmed){
          await this.$router.push({ name: 'EmailDetails', params: {
              email_id: response.id
            } }).catch(() => {
          })
        }
      })

      setTimeout(() => {
        if (this.$route.name !== 'EmailDetails') {
          this.$router.push({name: 'EmailDetails', params: {
              email_id: response.id
          }})
        }
      }, 2000);
    }
  },
  computed: {
    ...mapGetters('ModuleTableModule', [
      'moduleKeys'
    ]),
    disableAddButton() {
      return this.email_address.trim() === '' || this.modules.length === 0;
    }
  }
}
</script>

<template>
  <div class="modal fade" data-backdrop="static" id="NewEmail" tabindex="-1" role="dialog" aria-labelledby="NewEmailTitle" aria-hidden="true" ref="NewEmail">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <form class="modal-content" ref="NewUserForm" @submit.prevent="">
        <div class="modal-header">
          <h5 class="modal-title" id="newUserTitle">ADD EMAIL</h5>
        </div>
        <div class="modal-body">
          <div class="form-group row no-gutters mb-1">
            <label for="email_address" class="font-weight-bold col-sm-3 col-form-label">Email Address</label>
            <div class="col-sm-9">
              <input type="text" v-model="email_address" id="email_address" class="form-control form-control-sm" required>
            </div>
          </div>

          <div class="form-group row no-gutters mb-1">
            <label for="audit_type_1" class="font-weight-bold col-sm-3 col-form-label">Modules</label>
            <div class="col-sm-9">
              <div class="form-check" v-for="module in moduleKeys">
                <input class="form-check-input checkbox-input" type="checkbox" :value="module.code" :id="module.code" v-model="modules">
                <label :for="module.code" class="module_label font-weight-bold col-form-label no-select cursor-pointer">{{ module.name }}</label>
              </div>
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary" @click="cancelAdd" data-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-sm btn-primary" @click="addNewEmail" :disabled="disableAddButton">Add</button>
        </div>
      </form>
    </div>
  </div>

</template>

<style scoped>
.module_label {
  padding-bottom: 0;
  padding-top: 7px;
  margin-top: 0;
  margin-bottom: 0;
}
</style>
